<template>
  <aside v-if="isLoaded">
    <div class="side-logo">
      <router-link :to="{name:'Home'}">
        <img :srcset="$store.getters.settings.client.logo_4x +' 2x'" :src="$store.getters.settings.client.logo" alt=""/>
      </router-link>
    </div>
    <nav class="side-nav">
      <ul class="main-menu">
        <!--<li class="main-menu__item" :class="{'main-menu__item&#45;&#45;selected':$route.name==='Home'}">-->
          <!--<router-link :to="{name:'Home'}"-->
                       <!--class="main-menu__item&#45;&#45;link"-->
                       <!--:class="{'selected-item':$route.name==='Home'}">-->
            <!--{{ home.title }}-->
          <!--</router-link>-->
        <!--</li>-->
        <menu-section v-for="(section,index) in sections"
                      :key="section.id"
                      :index="index"
                      :section="section">
        </menu-section>

        <li class="main-menu__item" :class="{'main-menu__item--selected':$route.name==='Contact'}">
          <router-link :to="{name:'Contact'}" class="main-menu__item--link"
                       :class="{'selected-item':$route.name==='Contact'}">
            Contact Information
          </router-link>
        </li>
        <li class="main-menu__item" :class="{'main-menu__item--selected':$route.name==='Download'}">
          <router-link :to="{name:'Download'}" class="main-menu__item--link"
                       :class="{'selected-item':$route.name==='Download'}">
            Download Center
          </router-link>
        </li>
      </ul>
    </nav>
    <div class="menu-border" v-if="isLoaded"></div>
  </aside>
</template>
<script>
  import menuSection from './MenuSection.vue'

  export default {
    created () {
      this.getSections()
    },
    components: {
      menuSection
    },
    data () {
      return {
        home: {}
      }
    },
    methods: {
      getSections () {
        this.$store.dispatch('setIsLoaded', false)
        this.axios.get('/sections')
          .then(response => {
            this.$store.dispatch('setSections', response.data.sections)
            this.$store.dispatch('setIsLoaded', true)
            this.home = response.data.sections[0]
          })
          .catch(error => {
            console.log(error)
          })
      },
      openSubSection (section) {}
    },
    computed: {
//      home () {
//        return this.$store.getters.sections[0]
//      },
      isLoaded () {
        return this.$store.getters.isLoaded
      },
      sections () {
        return this.$store.getters.sections
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/layout/Menu.vue